import {Avatar} from '@jobseeker/lotus/components';
import {useIsLargeDevice} from '@jobseeker/lotus/hooks';
import {Box, Typography} from '@mui/material';

export type RecruiterInfoProps = {
  name: string;
  organization?: string;
  profilePicture?: string;
  confidential?: boolean;
};

const RecruiterInfo = ({
  name = '',
  organization = '',
  profilePicture = '',
  confidential = false,
}: RecruiterInfoProps) => {
  const isAboveLarge = useIsLargeDevice(900);
  return (
    <>
      <Box display="flex" gap={2}>
        {isAboveLarge && (
          <Avatar
            imgUrl={confidential ? '' : profilePicture}
            sx={{
              borderRadius: '10px',
              width: '50px',
              height: '50px',
            }}
          />
        )}
        <Box>
          <Typography fontSize={14} lineHeight={1.2} fontWeight={200}>
            Posted by
          </Typography>
          <Typography fontSize={14} lineHeight={1.2} fontWeight={600}>
            {confidential ? 'Verified Recruiter' : name}
          </Typography>
          {!confidential && (
            <Typography fontSize={14} lineHeight={1.2} fontWeight={200}>
              {organization}
            </Typography>
          )}
        </Box>
      </Box>
    </>
  );
};

export default RecruiterInfo;
